export default "__VITE_ASSET__CHP7U2cA__"